module.exports = __webpack_public_path__ + "img/wine rack Dog.9e12b494.png";